export default class LocationBadmanRun extends Phaser.Sprite {
  constructor(game, layer) {
    super(game);

    this.id = 'runsimpleback';
    this.layer = layer;
    this.lifeTime = 0;
    this.costume = this.game.make.image(0, 0, 'runsimpleback');
    this.addChild(this.costume);
  }

  get width() {
    return this.costume.width;
  }
  get height() {
    return this.costume.height;
  }

  update() {
    this.lifeTime += this.game.time.elapsedMS;
    this.costume.y = Math.sin(this.lifeTime) * 5;
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/story/sprites/LocationBadmanRun.js